export default "__VITE_ASSET__eXISG_Ay__"